<div class="flex-column flex-wrap occasion-selector-stores">
  @if (stores()?.length > 1) {
    <mat-form-field style="width: 100%; margin-bottom: -20px;">
      <mat-label>Select Store</mat-label>
      <mat-select placeholder="Choose your store" (selectionChange)="setSelectedStore($event.value)">
        <mat-select-trigger>
          {{ selectedStore?.Name }}
        </mat-select-trigger>

        <mat-option [value]="store" *ngFor="let store of stores()">
          <div class="flex-column no-wrap" style="line-height: initial; padding: 10px 0; font-size: 14px;">
            <strong>{{ store.Name }}</strong>
            <span class="address" *ngIf="store.Address">{{ store.Address.Line1 + ' ' + store.Address.Town  }}</span>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  }

  @if (selectedStore) {
    <div class="selected-store-details flex-column no-wrap">
      <strong [innerHTML]="openingTimeStatus.value"></strong>

      <div class="flex-row-centered" style="justify-content: start; line-height: initial; margin: 5px 0;">
        <span class="material-symbols-outlined" style="transform: rotateY(180deg); margin-right: 5px;">phone_enabled</span>
        <a [href]="getPhoneNumber(selectedStore.Phone)" *ngIf="selectedStore.Phone">{{ selectedStore.Phone }}</a>
      </div>

      <div class="flex-row-centered" style="justify-content: start; line-height: initial; margin: 5px 0;">
        <span class="material-symbols-outlined" style="margin-right: 5px;"> location_on </span>
        <span>{{ selectedStore.Address?.Line1 + ', ' + selectedStore.Address?.Town + ', ' + selectedStore.Address?.Postcode }}</span>
      </div>
    </div>
  }
</div>

<div class="takeaway-tab-content flex-center flex-align-center" style="height: unset; margin-top: 20px;">
  <button class="_home-page-content-tab-button button-action-1"
          [class.button-action-disabled]="!openingTimeStatus || (!openingTimeStatus.isOpen && !openingTimeStatus.openLater)"
          (click)="onOrderNow(selectedStore ?? stores()[0])"
          [disabled]="!openingTimeStatus || (!openingTimeStatus.isOpen && !openingTimeStatus.openLater)">
    <div class="_home-page-content-tab-button-text"> Order Now </div>
    <span class="material-symbols-outlined"> arrow_right_alt </span>
  </button>
</div>
